/**
 * Dates in LF-Kotlin schemas are represented as strings, while in LF-Storage are stored as JS Dates.
 * As such they need to be converted.
 *
 * Given a list of object property paths, return a function that will replace the string at the final property
 * of each path with the parsed JS Date.
 * E.g.
 * <pre>
 * convertDatesAtPaths([['foo', 'bar'], ['quux']])(obj);
 * //is equivalent to:
 * obj.foo.bar = new Date(obj.foo.bar)
 * obj.quux = new Date(obj.quux)
 * </pre>
 */
export function convertDatesAtPathsJson2Js(paths) {
  return replaceAtPaths(paths, dateStr => dateStr ? new Date(dateStr) : undefined);
}

const DATE_FORMAT = 'yyyy-MM-dd';
export function convertDatesAtPathsJs2Json(paths) {
  return replaceAtPaths(paths, jsDate => jsDate ? jsDate.toISOString().slice(0, DATE_FORMAT.length) : null);
}

/**
 * Returns a function that replaces property values of targetObj at the end of each path.
 * Uses fn to get the new value from the existing value.
 * Skips paths that do not exist.
 *
 * e.g.
 * <pre>
 * replaceAtPaths(['foo', 'bar', 'quux'], i => i*2)({foo: 5, bar: 10})
 * //-> {foo: 10, bar: 20}
 * </pre>
 *
 * Note: targetObj is mutated.
 **/
function replaceAtPaths(paths, fn) {
  return function doAtPathsFn(targetObj) {
    const NULL_OBJ = {};
    for (const path of paths) {
      let obj = targetObj;
      for (const field of path.slice(0, -1)) {
        obj = obj[field] || NULL_OBJ;
      }
      if (obj === NULL_OBJ) continue;
      const lastField = path[path.length - 1];
      const fieldValue = obj[lastField];
      obj[lastField] = fn(fieldValue);
    }
    return targetObj;
  };
}
